import React, { Component } from "react";
import { Label, Input, Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, faSmileWink } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

class StartPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorInput: "",
    };
  }

  setSessionName = () => {
    var inputName = document.getElementById("startpage-input").value.trim();
    if (/^ *$/.test(inputName)) {
      this.setState({
        errorInput: "startpage-input-error",
      });
    } else {
      window.sessionStorage.setItem(
        "uName",
        inputName.charAt(0).toUpperCase() + inputName.slice(1)
      );
      this.props.history.push("/home");
    }
  };

  componentDidMount() {
    var sessionName = window.sessionStorage.getItem("uName");
    if (sessionName !== null) {
      this.props.history.push("/home");
    } else {
      window.sessionStorage.clear();
    }
  }

  render() {
    return (
      <div className="startpage-container">
        <div id="startpage-form">
          <Label for="name" className="startpage-label text-secondary">
            First, may I know your name?
          </Label>
          <Input
            type="text"
            id="startpage-input"
            className={"shadow-none rounded-0 " + this.state.errorInput}
            placeholder="Please enter your name"
            autoComplete="off"
            autoFocus
            onChange={(e) => this.setState({ errorInput: "" })}
          />
          <p className="startpage-info text-info d-block mt-2">
            <FontAwesomeIcon icon={faInfoCircle} className="mr-1" />
            Yes, anything will do!
            <FontAwesomeIcon icon={faSmileWink} className="ml-1" />
          </p>
          <Button
            className="rounded-0 submit-btn mr-3 main-btn-color"
            onClick={this.setSessionName}
          >
            Submit
          </Button>
          <Link to="/home" className="btn cancel-btn rounded-0 submit-btn">
            No
          </Link>
        </div>
      </div>
    );
  }
}

export default StartPage;
